import APIClient from './index';
import _ from 'lodash';

/**
 * Send an announcement to a list of users (chat message + push).
 * Brand is determined on the backend.
 * @param {Object} params
 * @param {string} params.messageHeadline
 * @param {string} params.messageBody
 * @param {string} params.pushHeadline
 * @param {string} params.pushBody
 * @param {string} [params.attachmentUrl]
 * @param {Object} params.audience
 * @param {Array<Array<number>>} [params.audience.tagIds]
 * @param {number[]} [params.audience.userIds]
 */
export const announceMessage = params => {
  return new Promise((resolve, reject) => {
    APIClient.post('ChatMessages/announce', params)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error') || err));
  });
};

/**
 * Preview the number of users matching an audience before sending.
 * @param {Object} audience
 * @param {Array<Array<number>>} [audience.tagIds]
 * @param {number[]} [audience.userIds]
 * @returns {Promise<{ count: number }>}
 */
export const previewAudienceCount = audience => {
  return new Promise((resolve, reject) => {
    APIClient.post('ChatMessages/announce/preview', { audience })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error') || err));
  });
};
